import { apiBaseUrl } from '../api/base-url.js'

// Two-step upload: ask the API for a presigned PUT, PUT the file to S3, then
// tell the API the upload is complete. Throws on any failure.
export async function uploadAssistanceDoc(token: string, file: File): Promise<void> {
  const base = apiBaseUrl()
  const urlRes = await fetch(`${base}/public/assistance/upload-url`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({ token, contentType: file.type, sizeBytes: file.size }),
  })
  if (!urlRes.ok) throw new Error('upload_url_failed')
  const { url, objectKey } = (await urlRes.json()) as { url: string; objectKey: string }

  const put = await fetch(url, {
    method: 'PUT',
    headers: { 'content-type': file.type },
    body: file,
  })
  if (!put.ok) throw new Error('s3_put_failed')

  const done = await fetch(`${base}/public/assistance/complete`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      token,
      objectKey,
      fileName: file.name,
      contentType: file.type,
      sizeBytes: file.size,
    }),
  })
  if (!done.ok) throw new Error('complete_failed')
}
